import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, CheckCircle2 } from "lucide-react";

// Captures the browser's install prompt and lets the user install the tablet PWA.
export default function InstallPWA({ className = "" }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(
    typeof window !== "undefined" && window.matchMedia("(display-mode: standalone)").matches
  );

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };

  if (installed) {
    return (
      <div className={`flex items-center gap-2 text-sm text-emerald-600 font-medium ${className}`} data-testid="pwa-installed">
        <CheckCircle2 className="w-4 h-4" /> App instalada en este dispositivo
      </div>
    );
  }

  if (prompt) {
    return (
      <Button onClick={install} variant="outline" className={`rounded-full font-bold gap-2 border-2 ${className}`} data-testid="pwa-install-btn">
        <Download className="w-4 h-4" /> Instalar app para tablet
      </Button>
    );
  }

  // Fallback when the browser hasn't fired the prompt (iOS/Safari or already dismissed).
  return (
    <p className={`text-xs text-muted-foreground max-w-xs ${className}`} data-testid="pwa-install-hint">
      Para instalar en tablet: abre este panel en Chrome/Safari y elige <strong>“Agregar a pantalla de inicio”</strong>.
    </p>
  );
}
